// extracted by mini-css-extract-plugin
export var root = "News-root-Bxy5m";
export var rootCol = "News-root_col-yZQUS";
export var rootDark = "News-root-dark-ap69C";
export var rootDescription = "News-root_description-FUd6d";
export var rootHeading = "News-root_heading-Cf412";
export var rootIcon = "News-root_icon-zjskI";
export var rootItem = "News-root_item-qrkIp";
export var rootItemComments = "News-root_itemComments-EE6Gx";
export var rootItemDescription = "News-root_itemDescription-FLVZT";
export var rootItemDetails = "News-root_itemDetails-JOyRZ";
export var rootItemDetailsWrapper = "News-root_itemDetailsWrapper-V+ihF";
export var rootItemHeading = "News-root_itemHeading-Q-aUk";
export var rootItemPicture = "News-root_itemPicture-PwXbJ";
export var rootItemPicturePlaceholder = "News-root_itemPicturePlaceholder-7qXwB";
export var rootItemPictureWrapper = "News-root_itemPictureWrapper-v+dye";
export var rootItemReadMore = "News-root_itemReadMore-KzbcM";
export var rootItemTextContent = "News-root_item_textContent-sW2mh";
export var rootRow = "News-root_row-doavn";
export var rootSmall = "News-root-small-tHFHU";
export var rootWrapper = "News-root_wrapper-IVBL+";